import PropTypes from "prop-types";
import React from "react";
import ReactSlider from "react-slider";

class PriceSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prices: [
        { label: "No Minimum", value: 0 },
        { label: "No Maximum", value: 1000000000 },
      ],
      minIndex: 0,
      maxIndex: 1,
    };
  }

  componentDidMount = () => {
    this.setPrices(this.props.listingType);
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.listingType !== this.props.listingType) {
      this.setPrices(nextProps.listingType);
    } else if (
      nextProps.min !== this.props.min ||
      nextProps.max !== this.props.max
    ) {
      this.setState({
        minIndex: this.findIndex(this.state.prices, nextProps.min, 0),
        maxIndex: this.findIndex(
          this.state.prices,
          nextProps.max,
          this.state.prices.length - 1
        ),
      });
    }
  };

  setPrices = (listingType) => {
    const regionData = this.props.region;
    const prices =
      listingType === "rental"
        ? regionData.rentalPrices || []
        : regionData.salePrices;
    this.setState({
      prices: prices,
      minIndex: this.findIndex(prices, this.props.min, 0),
      maxIndex: this.findIndex(prices, this.props.max, prices.length - 1),
    });
  };

  findIndex = (prices, value, fallback) => {
    let foundIndex = fallback;
    prices.forEach(function (price, index) {
      if (price.value === value) {
        foundIndex = index;
      }
    });
    return foundIndex;
  };

  handleSliderChange = (values) => {
    this.setState({
      minIndex: values[0],
      maxIndex: values[1],
    });
    const minValue = this.state.prices[values[0]].value;
    const maxValue = this.state.prices[values[1]].value;
    this.props.handleChange(minValue, maxValue);
  };

  render() {
    let slider = null;
    if (this.state.prices.length > 2) {
      slider = (
        <ReactSlider
          key={this.props.listingType}
          className="horizontal-slider"
          thumbClassName="dragger-btn"
          defaultValue={[this.state.minIndex, this.state.maxIndex]}
          min={0}
          max={this.state.prices.length - 1}
          minDistance={1}
          ariaLabel={["Lower thumb", "Upper thumb"]}
          trackClassName="dragger-bar-selected-range"
          onAfterChange={this.handleSliderChange.bind(this)}
        />
      );
    }
    return (
      <div
        className={
          "search-input x-large price-selector-input hidden-xxs " +
          this.props.className
        }
      >
        <h2>Price</h2>
        <div className="selector-controls">
          <div className="price-min-max-display">
            {this.state.prices[this.state.minIndex].label}
            &nbsp;-&nbsp;
            {this.state.prices[this.state.maxIndex].label}
          </div>
          <div className="dragger-bar"></div>
          {slider}
        </div>
      </div>
    );
  }
}

PriceSlider.propTypes = {
  handleChange: PropTypes.func.isRequired,
  listingType: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  region: PropTypes.object.isRequired,
};

export default PriceSlider;



// WEBPACK FOOTER //
// ./src/components/search/controls/price-slider.jsx